import React, { useContext, useEffect, useState } from "react";
import style from "./index.module.scss";
import { Radio } from "antd";
import { findOneValue, OptionItem, TopicsItem } from "../../../../../service";
import { RadioChangeEvent } from "antd/lib/radio";
import { QuestionnaireContext } from "../../../../../store";

interface PageRadioProps {
    index?: number;
    data: TopicsItem;
    oneSave: (questionId: string, value: string) => void;
}

export default function PageRadio({ data, oneSave, index }: PageRadioProps) {
    const [value, setValue] = useState("");
    const { questionnaire } = useContext(QuestionnaireContext);

    useEffect(() => {
        if (data.id && questionnaire.length > 0) {
            let val = findOneValue(data.id, questionnaire);
            setValue(val);
        }
    }, [data, questionnaire]);

    function groupChange(event: RadioChangeEvent) {
        setValue(event.target.value);
        oneSave(data.id, event.target.value);
    }

    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（单选题）</span>
            </div>
            <div className={style.title}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>

            <div className={style.options}>
                <Radio.Group onChange={groupChange} value={parseInt(value)}>
                    {data.options &&
                        data.options.map((item: OptionItem, index: number) => (
                            <Radio
                                value={item.id}
                                key={item.id}
                                className={style.radioStyle}>
                                <span className={style.letter}>
                                    {String.fromCharCode(65 + index)}.
                                </span>
                                <span
                                    className={style.spanHtml}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Radio>
                        ))}
                </Radio.Group>
            </div>
        </div>
    );
}
